export default "__VITE_ASSET__Dyf2Issp__"